import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  Alert,
  Spinner,
  CardTitle,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import ExpenseHeader from "../ExpenseDashboard/ExpenseHeader";
// import Header from "./Header";

const AddExpenseCategory = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState({ name: "", description: "" });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ message: "", type: "" });

  const API_URL = "https://api.hanoch.in/expense/categories/";

  // 🔹 Fetch all categories from backend
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_URL);
      setCategories(res.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setLoading(false);
    }
  };

  // 🔹 Handle input changes
  const handleChange = (e) => {
    setCategory({ ...category, [e.target.name]: e.target.value });
  };

  // 🔹 Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!category.name || !category.description) {
      setAlert({ message: "Please fill all fields", type: "danger" });
      return;
    }

    try {
      await axios.post(API_URL, category);
      setAlert({ message: "Category added successfully!", type: "success" });
      setCategory({ name: "", description: "" });
      fetchCategories(); // refresh list
    } catch (error) {
      console.error("Error adding category:", error);
      setAlert({ message: "Failed to add category", type: "danger" });
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <>
     <ExpenseHeader/>
      <Container className="mt-4">
      

        {/* 🔔 Alert Messages */}
        {alert.message && (
          <Alert
            color={alert.type}
            toggle={() => setAlert({ message: "", type: "" })}
          >
            {alert.message}
          </Alert>
        )}

        {/* 🧾 Add Category Form */}
        <Card className="mb-4 shadow-sm">
          <CardTitle  tag="h6"className="p-2 text-primary"><h4 className="text-info"> Add Expense Category </h4></CardTitle>
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Category Name</Label>
                    <Input
                      type="text"
                      name="name"
                      value={category.name}
                      onChange={handleChange}
                      placeholder="Enter category name"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Category Description</Label>
                    <Input
                      type="text"
                      name="description"
                      value={category.description}
                      onChange={handleChange}
                      placeholder="Enter category description"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Button color="primary" type="submit">
                Add Category
              </Button>
            </Form>
          </CardBody>
        </Card>

        {/* 📋 Category List */}
        <Card className="shadow-sm">
          <CardHeader>Existing Categories</CardHeader>
          <CardBody>
            {loading ? (
              <div className="text-center my-4">
                <Spinner color="primary" />
              </div>
            ) : (
              <Table bordered responsive hover>
                <thead className="table-light">
                  <tr>
                   
                    <th>Name</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((cat) => (
                    <tr key={cat.id}>
                     
                      <td>{cat.name}</td>
                      <td>{cat.description}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            
                )
            }
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default AddExpenseCategory;
